import React from 'react';

import "./JoinUs.scss";
import { Article } from '../../elements/Article/Article';

export const JoinUs = (props)=>{
    const {} = props;
    
    return (
        <section className="JoinUs">
            <Article className="block wall" src="web-joinUs" level={0}/>
        </section>
    )
}

